import { isNullOrUndefined } from "../../../../../../../../tools";
import { IdProvider } from "../../../../../../../services/idprovider.service";
import { ServerCommunicatorService } from "../../../../../../../services/server-communicator.service";
import { UIUtils } from "../../../../../../../services/uiutils.service";
import { Utils } from "../../../../../../../services/utils.service";
import { DataContainer } from "../../../../../../infrastructure/datacontainer";
import { DataContainerService } from "../../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../../infrastructure/enums";
import { IPersistable } from "../../../../../../infrastructure/IPersistable";
import { PayloadPacketFacade } from "../../../../../../infrastructure/payloadpacket/payloadpacketfacade";
import { TransportData } from "../../../../../../infrastructure/transportdata";
import { ValidationResultAccumulator } from "../../../../../../infrastructure/validationresultaccumulator";
import { DcmPostMasterFetchRequest, DCMPostNameFetchRequest } from "./dcmpostfetchrequest";

export class DcmPostMasterProps {

public created_date: string = '';
  public updated_date: string = '';
  public created_by: number = 0;
  public updated_by: number = 0;
  public deleted_by: number = 0;

  public id: number = 0;
  public state_id: number = 0;
  public readonly state_name_en: string = '';
  public readonly state_name_mr: string = '';
  public zone_id: number = 0;
  public readonly zone_name: string = '';
  public district_id: number = 0;

  // public dcm_post_number : number = 0;
  public readonly district_name_en: string = '';
  public readonly district_name_mr: string = '';
  public name: string = '';
  public dcm_post_id: number = 0;

  public financial_year_id: number = 0;

  public readonly is_newly_created: boolean = false;

  private constructor(IsNewlyCreated: boolean) {
    this.is_newly_created = IsNewlyCreated;
  }

  public static Blank() {
    return new DcmPostMasterProps(true);
  }
}

export class DcmPostMaster implements IPersistable<DcmPostMaster> {
  public static readonly mastertablename: string = 'dcm_post';

  private constructor(public readonly p: DcmPostMasterProps, public readonly AllowEdit: boolean) {

  }

  public async EnsurePrimaryKeysWithValidValues(): Promise<void> {
    if (this.p.id === undefined || this.p.id === 0) {
      const newids = await IdProvider.GetInstance().GetNextEntityId();
      // const newids = await IdProvider.GetInstance().GetAllocateSingleIds();
      this.p.id = newids[0];
      if (this.p.id <= 0) throw new Error("Cannot assign Id. Please try again");
    }
  }

  public GetEditableVersion(): DcmPostMaster {
    let newDcmPostMaster: DcmPostMasterProps = Utils.GetInstance().DeepCopy(this.p);
    return DcmPostMaster.CreateInstance(newDcmPostMaster, true);
  }

  public static CreateNewInstance() {
    return new DcmPostMaster(DcmPostMasterProps.Blank(), true);
  }

  public static CreateInstance(data: any, allowEdit: boolean) {
    return new DcmPostMaster(data as DcmPostMasterProps, allowEdit);
  }

  public CheckSaveValidity(_td: TransportData, vra: ValidationResultAccumulator): void {
    if (!this.AllowEdit) vra.add('', 'This object is not editable and hence cannot be saved.');
    if (!this.p.name || this.p.name.trim() == '') { vra.add('name', 'DcmPostMaster Name cannot be blank. ');
    }
    // if (this.p.StateRef <= 0) vra.add('StateRef', 'State cannot be blank. ');
    // if (this.p.zone_id <= 0) vra.add('zone_id', 'Zone cannot be blank. ');
    // if (this.p.DistrictRef <= 0) vra.add('DistrictRef', 'District cannot be blank. ');
    // if (this.p.BlockRef <= 0) vra.add('BlockRef', 'Block cannot be blank. ');
    // if (this.p.SanctionedNoOfAsha < 0) vra.add('SanctionedNoOfAsha', 'Sanctioned  No Of Asha cannot be negative. ');
    if (this.p.district_id  <= 0) vra.add('district_id', 'District Name cannot be Blank.');
  
  }

  public MergeIntoTransportData(td: TransportData) {
    DataContainerService.GetInstance().MergeIntoContainer(td.MainData, DcmPostMaster.mastertablename, this.p);
  }

  private static m_currentInstance: DcmPostMaster = DcmPostMaster.CreateNewInstance();

  public static GetCurrentInstance() {
    return DcmPostMaster.m_currentInstance;
  }

  public static SetCurrentInstance(value: DcmPostMaster) {
    DcmPostMaster.m_currentInstance = value;
  }

  // ********************************************
  public static cacheDataChangeLevel: number = -1;

  public static SingleInstanceFromTransportData(td: TransportData): DcmPostMaster {
    let dcs = DataContainerService.GetInstance();
    if (dcs.CollectionExists(td.MainData, DcmPostMaster.mastertablename)) {
      for (let data of dcs.GetCollection(td.MainData, DcmPostMaster.mastertablename)!.Entries) {
        return DcmPostMaster.CreateInstance(data, false);
      }
    }

    return null as any;
  }

  public static ListFromDataContainer(cont: DataContainer,
    filterPredicate: (arg0: any) => boolean = null as any,
    sortPropertyName: string = "Name"): DcmPostMaster[] {
    let result: DcmPostMaster[] = [];

    let dcs = DataContainerService.GetInstance();

    if (dcs.CollectionExists(cont, DcmPostMaster.mastertablename)) {
      let coll = dcs.GetCollection(cont, DcmPostMaster.mastertablename)!;
      let entries = coll.Entries;

      if (!isNullOrUndefined(filterPredicate)) entries = entries.filter(filterPredicate);

      if (sortPropertyName.trim().length > 0) {
        entries = Utils.OrderByPropertyName(entries, sortPropertyName);
      }

      for (let data of entries) {
        result.push(DcmPostMaster.CreateInstance(data, false));
      }
    }

    return result;
  }

  public static ListFromTransportData(td: TransportData): DcmPostMaster[] {
    return DcmPostMaster.ListFromDataContainer(td.MainData);
  }

  public static async FetchTransportData(req: DcmPostMasterFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = req.FormulateTransportData();
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
      return null;
    }

    let tdResponse = JSON.parse(tr.Tag) as TransportData;
    return tdResponse;
  }

  public static async FetchInstance(ref: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new DcmPostMasterFetchRequest();
    let tdResponse = await DcmPostMaster.FetchTransportData(req, errorHandler) as TransportData;
    return DcmPostMaster.SingleInstanceFromTransportData(tdResponse);
  }

  public static async FetchList(req: DcmPostMasterFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdResponse = await DcmPostMaster.FetchTransportData(req, errorHandler) as TransportData;
    return DcmPostMaster.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireList(errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new DcmPostMasterFetchRequest();
    let tdResponse = await DcmPostMaster.FetchTransportData(req, errorHandler) as TransportData;
    return DcmPostMaster.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireListByDistrict(district_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new DcmPostMasterFetchRequest();
   
     if (district_id) {
      req.district_ids.push(district_id);
    }
    let tdResponse = await DcmPostMaster.FetchTransportData(req, errorHandler) as TransportData;
    return DcmPostMaster.ListFromTransportData(tdResponse);
  }

    public static async FetchEntireListByAllFilters(zone_id: number, district_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new DcmPostMasterFetchRequest();

     if (zone_id) {
      req.zone_ids.push(zone_id);
    }
   
     if (district_id) {
      req.district_ids.push(district_id);
    }
    let tdResponse = await DcmPostMaster.FetchTransportData(req, errorHandler) as TransportData;
    return DcmPostMaster.ListFromTransportData(tdResponse);
  }

     public static async FetchEntireListByDistrictRef( district_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new DCMPostNameFetchRequest();
     if (district_id) {
      req.district_ids.push(district_id);
    }
    let tdResponse = await DcmPostMaster.FetchTransportData(req, errorHandler) as TransportData;
    return DcmPostMaster.ListFromTransportData(tdResponse);
  }
    

  public async DeleteInstance(successHandler: () => Promise<void> = null!, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = new TransportData();
    tdRequest.RequestType = RequestTypes.Deletion;

    this.MergeIntoTransportData(tdRequest);
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
    }
    else {
      if (!isNullOrUndefined(successHandler)) await successHandler();
    }
  }

}
